export default __webpack_public_path__ + "static/media/graphic.a25bd776.svg";